/*
 * @Date: 2023-10-08 14:33:24
 * @Description: 主题文件相关
 */
import themes from "./types/index";
/**
 * @description: 获取菜单列表 ，具体根据 url 还是其他条件待定
 * @return {Array} 数组列表
 */
const getNowMenuList = (type = "base") => {
  // base chplt cptpp  rcep
  return themes[type];
};
const exportAllMenuList = () => {
  return [].concat(
    themes["base"],
    themes["chplt"],
    themes["cptpp"],
    themes["rcep"]
  );
};

export { getNowMenuList, exportAllMenuList };
